<template>
  <v-dialog v-model="dialog" fullscreen hide-overlay transition="none" style="overflow-x: hidden;">
    <v-card>

        <!-- <Spinner ref="spinner"></Spinner> -->

        <v-layout text-xs-center>
          <v-flex mb-0 xs12 mx-2>
            <v-layout justify-start row mx-3 mt-3 align-center>
              <v-flex>
                <div
                  class="text-xs-left"
                  style="font-size: 20px; font-weight: 600;"
                >Contacts List for Account # {{ accountBAN }} ({{ accountName }})</div>
              </v-flex>
              <v-flex>
                <v-layout row>
                  <v-flex>
                    <v-layout class="buttons mb-0 mr-0" justify-end row>
                      <v-btn icon @click="cancel" class="pa-0 mr-0">
                        <v-icon>fa-times</v-icon>
                      </v-btn>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>

            <v-layout justify-start row mx-3 mt-3 align-center>
              <v-flex>

                <v-data-table
                  :headers="headers"
                  :items="contacts"
                  class="striped-table"
                >
                  <template slot="items" slot-scope="props">
                    <tr :key="props.index">
                      <td class="text-xs-left pa-0">{{ props.item["SICONTACTTYPENAME"] }}</td>
                      <td class="text-xs-left pa-0">{{ props.item["SILANGUAGENAME"] }}</td>
                      <td class="text-xs-left pa-0">{{ props.item["ACNAME1"] }}</td>
                      <td class="text-xs-left pa-0">{{ props.item["ACNAME2"] }}</td>
                      <td class="text-xs-left pa-0">{{ formatPN_helper(props.item["ACPHONE"]) }} {{ props.item["ACPHONEEXTENSION"] ? 'x' + props.item["ACPHONEEXTENSION"] : '' }}</td>
                      <td class="text-xs-left pa-0">{{ formatPN_helper(props.item["ACALTPHONE"]) }} {{ props.item["ACALTPHONEEXT"] ? 'x' + props.item["ACALTPHONEEXT"] : '' }}</td>
                      <td class="text-xs-left pa-0">{{ formatPN_helper(props.item["ACFAX"]) }}</td>
                      <td class="text-xs-left pa-0">{{ formatPN_helper(props.item["ACMOBILEPHONE"]) }}</td>
                      <td class="text-xs-left pa-0">{{ props.item["ACEMAIL"] ? props.item["ACEMAIL"].toUpperCase() : '' }}</td>
                      <td class="text-xs-left pa-0">{{ props.item["ACNOTES"] }}</td>
                      <td class="justify-end align-center text-xs-right pr-0 pt-0 pb-0">
                        <a
                          class="mr-0 ml-2"
                          style="text-decoration: none"
                          @click="selectForEditting(props.item)"
                        >
                          EDIT
                        </a>
                      </td>
                    </tr>
                  </template>
                </v-data-table>

              </v-flex>
            </v-layout>

            <div class="mb-5"><zigZag></zigZag></div>

            <v-layout justify-start row mx-3 mt-3 align-center>
                <v-icon class="mr-2">fa-plus-circle</v-icon>
                <div
                  v-show="formType === 'add'"
                  class="text-xs-left"
                  style="font-size: 20px; font-weight: 600;"
                >Add Contact</div>
                <div
                  v-show="formType === 'edit'"
                  class="text-xs-left"
                  style="font-size: 20px; font-weight: 600;"
                >Edit Contact</div>
            </v-layout>

            <v-form v-model="valid" @submit="editContact" ref="AddEditContactForm">

                  <v-layout grid-list-md justify-start pa-0 ma-0 mr-0 pr-0 mt-2>
                    <v-layout hide-details justify-start row mt-0 mb-4>

                      <v-flex hide-details mx-4 xs3>
                        <v-autocomplete
                          hide-details
                          :items="ddlContactTypes"
                          v-model="selectedContact.SICONTACTTYPEID"
                          item-text="Text"
                          item-value="Value"
                          label=" Contact Type*"
                          @change="refreshFormTypeAndData"
                          clearable
                          required
                          :rules="ContactTypeRules"
                        ></v-autocomplete>
                        <v-autocomplete
                          hide-details
                          :items="ddlContactLanguages"
                          v-model="selectedContact.SILANGUAGEID"
                          item-text="Text"
                          item-value="Value"
                          label=" Contact Language*"
                          clearable
                          required
                          :rules="ContactLanguageRules"
                        ></v-autocomplete>
                      </v-flex>

                      <v-flex hide-details mx-4 xs3>
                        <v-text-field
                          style="max-height: 45px"
                          v-model="selectedContact.ACNAME1"
                          value="ACNAME1"
                          label="First Name*"
                          @input="forceUpperCase('ACNAME1')"
                          required
                          :rules="Name1Rules"
                        ></v-text-field>
                        <v-text-field
                          style="max-height: 45px"
                          v-model="selectedContact.ACNAME2"
                          value="ACNAME2"
                          label="Last Name"
                          @input="forceUpperCase('ACNAME2')"
                        ></v-text-field>
                        <v-text-field
                          style="max-height: 45px"
                          v-model="selectedContact.ACEMAIL"
                          value="ACEMAIL"
                          label="Email*"
                          @input="forceUpperCase('ACEMAIL')"
                          required
                          :rules="EmailRules"
                        ></v-text-field>
                      </v-flex>

                      <v-flex hide-details mx-4 xs3>

                         <v-layout>
                          <v-flex xs10 mr-4>
                            <v-text-field
                              style="max-height: 45px"
                              v-model="selectedContact.ACPHONE"
                              value="ACPHONE"
                              label="Phone"
                              :mask="phoneNumberMask"
                            ></v-text-field>
                          </v-flex>
                          <v-flex ml-2>
                            <v-text-field
                              style="max-height: 45px"
                              v-model="selectedContact.ACPHONEEXTENSION"
                              value="ACPHONEEXTENSION"
                              label="Ext."
                              mask="##########"
                            ></v-text-field>
                          </v-flex>
                        </v-layout>

                        <v-layout>
                          <v-flex xs10 mr-4>
                            <v-text-field
                              style="max-height: 45px"
                              v-model="selectedContact.ACALTPHONE"
                              value="ACALTPHONE"
                              label="Alt. Phone"
                              :mask="phoneNumberMask"
                            ></v-text-field>
                          </v-flex>
                          <v-flex ml-2>
                            <v-text-field
                              style="max-height: 45px"
                              v-model="selectedContact.ACALTPHONEEXT"
                              value="ACALTPHONEEXT"
                              label="Ext."
                              mask="##########"
                            ></v-text-field>
                          </v-flex>
                        </v-layout>

                        <v-text-field
                          style="max-height: 45px"
                          v-model="selectedContact.ACMOBILEPHONE"
                          value="ACMOBILEPHONE"
                          label="Cell"
                          :mask="phoneNumberMask"
                        ></v-text-field>
                        <v-text-field
                          style="max-height: 45px"
                          v-model="selectedContact.ACFAX"
                          value="ACFAX"
                          label="Fax"
                          :mask="phoneNumberMask"
                        ></v-text-field>
                      </v-flex>

                      <v-flex hide-details mx-4 xs3 style="margin-top: 73px; max-height: 151px;">
                        <v-textarea
                          v-model="selectedContact.ACNOTES"
                          value="ACNOTES"
                          label="Notes"
                          @input="forceUpperCase('ACNOTES')"
                        ></v-textarea>
                      </v-flex>

                    </v-layout>
                  </v-layout>

                  <v-layout hide-details justify-end row mt-0 mb-4>
                    <a
                      class="align-center mx-4 pt-3"
                      style="text-decoration: none"
                      @click="reset"
                    >RESET</a>
                    <v-btn
                      v-show="formType === 'add'"
                      color="success"
                      @click="createContact()"
                      class="ml-2 mr-4"
                    >
                      Create
                    </v-btn>
                    <v-btn
                      v-show="formType === 'edit'"
                      color="success"
                      @click="editContact()"
                      class="ml-2 mr-4"
                    >
                      Save
                    </v-btn>
                  </v-layout>

            </v-form>

          </v-flex>
        </v-layout>

    </v-card>
  </v-dialog>
</template>

<script>
import Spinner from '../../components/Spinner.vue';
import axios from "axios";
import Bus from "../../bus";
import zigZag from '../../components/ZigZag';

export default {
  name: "ManageContacts",

  components: {
    Spinner,
    zigZag,
  },

  data: () => ({
    dialog: false,
    valid: true,

    formType: 'add',

    accountBAN: '',
    accountName: '',
    phoneNumberType: '',
    phoneNumberMask: '',

    ddlContactTypes: [],
    ddlContactLanguages: [],

    ContactLanguageRules: [v => !!v || ""],
    ContactTypeRules: [v => !!v || ""],
    Name1Rules: [v => !!v || ""],
    EmailRules: [
      v => !!v || "",
      v => /.+@.+\..+/.test(v) || 'Email must be valid'
    ],

    contacts: [],

    selectedContact: {},

    headers: [
        {
          text: "Type",
          value: "ContactType",
          sortable: false,
          width: "8%",
          fixed: true,
          align: "left",
          class: "pa-0 font-weight-bold subheading sort-asc"
        },
        {
          text: "Language",
          value: "ContactLanguage",
          sortable: false,
          width: "7%",
          fixed: true,
          align: "left",
          class: "pa-0 font-weight-bold subheading sort-asc"
        },
        {
          text: "First Name",
          value: "FirstName",
          sortable: false,
          width: "7%",
          fixed: true,
          align: "left",
          class: "pa-0 font-weight-bold subheading sort-asc"
        },
        {
          text: "Last Name",
          value: "LastName",
          sortable: false,
          width: "7%",
          fixed: true,
          align: "left",
          class: "pa-0 font-weight-bold subheading sort-asc"
        },
        {
          text: "Phone",
          value: "Phone",
          sortable: false,
          width: "11%",
          fixed: true,
          align: "left",
          class: "pa-0 font-weight-bold subheading sort-asc"
        },
        {
          text: "Alt. Phone",
          value: "AltPhone",
          sortable: false,
          width: "11%",
          fixed: true,
          align: "left",
          class: "pa-0 font-weight-bold subheading sort-asc"
        },
        {
          text: "Fax",
          value: "Fax",
          sortable: false,
          width: "7%",
          fixed: true,
          align: "left",
          class: "pa-0 font-weight-bold subheading sort-asc"
        },
        {
          text: "Cell",
          value: "Cell",
          sortable: false,
          width: "7%",
          fixed: true,
          align: "left",
          class: "pa-0 font-weight-bold subheading sort-asc"
        },
        {
          text: "Email",
          value: "Email",
          sortable: false,
          width: "14%",
          fixed: true,
          align: "left",
          class: "pa-0 font-weight-bold subheading sort-asc"
        },
        {
          text: "Notes",
          value: "Notes",
          sortable: false,
          width: "13%",
          fixed: true,
          align: "left",
          class: "pa-0 font-weight-bold subheading sort-asc"
        },
        {
          text: "Actions",
          value: "actions",
          sortable: false,
          width: "8%",
          fixed: true,
          align: "right",
          class: "pa-0 font-weight-bold subheading sort-asc"
        },
      ],
  }),

  mounted() {
    this.initialize();
  },

  methods: {
    initialize () {
      // this.getDropdownOptions("api/Account/GetEditAccountDdls", "ddlAccountTypes")
    },

    // Get data for elements in component
    async getElementData(url, obj) {
      await axios
        .get(url)
        .then(resp => (this[`${obj}`] = resp.data[`${obj}`]))
        .catch(err => console.log(err));
    },

    // // Get account info from DB to populate form
    // async getAccountInfo(url, obj) {
    //   await axios
    //     .get(url)
    //     .then(resp => (this[`${obj}`] = resp.data))
    //     .catch(err => console.log(err));
    // },

    async open(item) {
      this.dialog = true;

      this.accountBAN = item.BAN
      this.accountName = item.Name1.trim() + ' ' + (item.Name2 ? item.Name2.trim() : '')
      this.phoneNumberType = item.phoneNumberType

      if (this.phoneNumberType === "N") {
        this.phoneNumberMask = '(###) ###-####'
      }

      await this.getElementData("api//Contacts/GetManageContactsInfo/" + item.BAN, "contacts")
      await this.getElementData("api//Contacts/GetManageContactsInfo/" + item.BAN, "ddlContactTypes")
      await this.getElementData("api//Contacts/GetManageContactsInfo/" + item.BAN, "ddlContactLanguages")

    },

    cancel() {
      this.dialog = false;

      this.reset()
    },

    reset() {
      this.formType = 'add'
      this.selectedContact = {}
      this.$refs.AddEditContactForm.resetValidation()
    },

    selectForEditting(item) {
      this.selectedContact = Object.assign({}, item);
      this.selectedContact.ACEMAIL = this.selectedContact.ACEMAIL ? this.selectedContact.ACEMAIL.toUpperCase() : null

      this.formType = 'edit'
    },

    async editContact() {
      if (this.$refs.AddEditContactForm.validate()) {
        this.selectedContact.ACEMAIL = this.selectedContact.ACEMAIL ? this.selectedContact.ACEMAIL.toLowerCase() : null
        let result = await this.saveContactChangesToDB()

        if (result) {
          this.$root.$emit("initialize", this.initialize);
          this.getElementData("api//Contacts/GetManageContactsInfo/" + this.accountBAN, "contacts")

          Bus.$emit("alert", {
            color: "success",
            message: "Contact Edited Successfully!"
          });
        }

        this.selectedContact.ACEMAIL = this.selectedContact.ACEMAIL ? this.selectedContact.ACEMAIL.toUpperCase() : null
        // window.location.reload();
      }
    },
    async saveContactChangesToDB() {

      let result = await axios.post("api/Contacts/EditContact", this.selectedContact);
      return result;
    },

    async createContact() {
      if (this.$refs.AddEditContactForm.validate()) {
        this.selectedContact.AccountNumber = this.accountBAN
        this.selectedContact.ACEMAIL = this.selectedContact.ACEMAIL ? this.selectedContact.ACEMAIL.toLowerCase() : null
        let result = await this.saveNewContactToDB()

        if (result) {
          this.$root.$emit("initialize", this.initialize);
          this.getElementData("api//Contacts/GetManageContactsInfo/" + this.accountBAN, "contacts")
          this.formType = 'edit'

          Bus.$emit("alert", {
            color: "success",
            message: "Contact Created Successfully!"
          });
        }

        this.selectedContact.ACEMAIL = this.selectedContact.ACEMAIL ? this.selectedContact.ACEMAIL.toUpperCase() : null
        // window.location.reload();
      }
    },
    async saveNewContactToDB() {

      let result = await axios.post("api/Contacts/CreateContact", this.selectedContact);
      return result;
    },

    forceUpperCase(prop) {
      this.selectedContact[`${prop}`] = this.selectedContact[`${prop}`].toUpperCase()
    },

    refreshFormTypeAndData(selection) {
      let tempContactArray = this.contacts.filter( contact => contact.SICONTACTTYPEID === selection)

      if (tempContactArray.length !== 0) {
        this.selectedContact = Object.assign({}, tempContactArray[0])
        this.selectedContact.ACEMAIL = this.selectedContact.ACEMAIL ? this.selectedContact.ACEMAIL.toUpperCase() : null

        this.formType = 'edit'
      } else {
        this.reset()
        this.selectedContact.SICONTACTTYPEID = selection
      }
    },

    formatPN_helper(num) {
      if (num && this.phoneNumberType === 'N') {
        let formattedNum = '(' + num.slice(0, 3) + ') ' + num.slice(3, 6) + '-' + num.slice(6)
        return formattedNum
      }

      return num
    },
  }
}
</script>

<style scoped>
.buttons-bottom {
  position: fixed;
  bottom: 40px;
  right: 500px;
}
table.v-table tbody td,
table.v-table tbody th {
  height: 22px;
  font-size: 14px;
}

table.v-table tbody th {
  background-color: #4caf50;
}

table.v-table tbody tr:not(:last-child) {
  height: 22px;
  font-size: 14px;
}
.TierButton {
  border-color: #4caf50 !important;
  border-width: 1px !important;
  border-style: solid !important;
  color: #4caf50 !important;
  box-shadow: none !important;
  background-color: transparent !important;
}
.TierButton:hover {
  background-color: #4caf50 !important;
  color: white !important;
}
</style>

